import { useState, useEffect } from 'react'

// Can we use this 'baseUse' in use hooks for data request?
const baseUse = getElements => {
  const [elements, setElements] = useState([])

  useEffect(() => {
    getElements()
      .then(response => setElements(response.data))
      .catch(console.log)
  }, [])

  return elements
}

export default baseUse
